export default "__VITE_ASSET__BFdnxSJD__"